
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// types
import { ContractTypeT } from '@/core/types/contracts.types'

// classes
import { DataState } from '@/core/classes/DataState.class'
import { contracts } from '@/core/realisations/contracts.realisation'

export default defineComponent({
    components: {
        TheInput,
        TheButton,
        TheSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['resetted', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            bin: null as string | null,
            companyShortName: null as string | null,
            email: null as string | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
            typeIds: [] as number[],
        })

        const data_state = reactive({
            contract_types: new DataState<ContractTypeT>({}),
        })

        const reset = () => {
            if (props.loading) return

            state.bin = null
            state.companyShortName = null
            state.email = null
            state.createdAtFrom = null
            state.createdAtTo = null
            state.typeIds = []

            emit('resetted')
        }

        const search = () => {
            if (props.loading) return

            emit('search', {
                ...state,
            })
        }

        // contracts

        const loadContractTypes = async (page: number) => {
            data_state.contract_types.pagination.current_page = page

            try {
                data_state.contract_types.is_loading = true

                const response = await contracts.getTypes({ page })
                data_state.contract_types.list = response.data
                data_state.contract_types.pagination.total_pages = response.meta.last_page

                data_state.contract_types.is_failed = false
                data_state.contract_types.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.contract_types.failure.catchError(error)

                if (!data_state.contract_types.failure.error_state.is_cancel) {
                    data_state.contract_types.is_failed = true
                }
            } finally {
                if (!data_state.contract_types.failure.error_state.is_cancel) {
                    data_state.contract_types.is_loading = false
                }
            }
        }

        const loadMoreContractTypes = async (page: number) => {
            if (page > data_state.contract_types.pagination.total_pages) return
            data_state.contract_types.pagination.current_page = page

            try {
                data_state.contract_types.is_loading = true

                const response = await contracts.getTypes({ page })
                data_state.contract_types.list = data_state.contract_types.list.concat(
                    response.data
                )

                data_state.contract_types.pagination.total_pages = response.meta.last_page

                data_state.contract_types.is_failed = false
                data_state.contract_types.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.contract_types.failure.catchError(error)

                if (!data_state.contract_types.failure.error_state.is_cancel) {
                    data_state.contract_types.is_failed = true
                }
            } finally {
                if (!data_state.contract_types.failure.error_state.is_cancel) {
                    data_state.contract_types.is_loading = false
                }
            }
        }

        //

        onBeforeMount(() => {
            loadContractTypes(1)
        })

        return {
            state,
            data_state,
            //
            reset,
            search,
            loadContractTypes,
            loadMoreContractTypes,
        }
    },
})
